// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"
import { useRef, useState, useEffect, useCallback } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { far } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Spinner } from "../Spinner"
import { Tooltip } from "../Tooltip"

const __rest =
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  (this && this.__rest) ||
  function (s: any, e: any) {
    const t = {}
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
      // @ts-expect-error TS(2403): Subsequent variable declarations must have the sam... Remove this comment to see the full error message
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          t[p[i]] = s[p[i]]
      }
    return t
  }

library.add(fas, fab, far)
const spinnerSizes = {
  xs: 15,
  sm: 20,
  md: 25,
  lg: 30,
  xl: 40,
}
export const Button = (_a: any) => {
  const {
    type = "button",
    color = "primary",
    size = "md",
    className = "",
    disabled = false,
    backgroundColor,
    label,
    icon,
    iconPosition = "left",
    iconLibrary = "fab",
    tooltipText = "",
    rounded = false,
    link = false,
    loading = false,
    variant = "contained",
    onClick,
  } = _a
  const props = __rest(_a, [
    "type",
    "color",
    "size",
    "className",
    "disabled",
    "backgroundColor",
    "label",
    "icon",
    "iconPosition",
    "iconLibrary",
    "tooltipText",
    "rounded",
    "link",
    "loading",
    "variant",
    "onClick",
  ])
  const containerRef = useRef(null)
  const [width, setWidth] = useState()
  const [height, setHeight] = useState()
  const [_loading, setLoading] = useState(false)
  useEffect(() => {
    let _a
    let _b
    if (loading) {
      setWidth(
        (_a =
          containerRef === null || containerRef === void 0
            ? void 0
            : containerRef.current) === null || _a === void 0
          ? void 0
          // @ts-expect-error TS(2339): Property 'clientWidth' does not exist on type 'nev... Remove this comment to see the full error message
          : _a.clientWidth
      )
      setHeight(
        (_b =
          containerRef === null || containerRef === void 0
            ? void 0
            : containerRef.current) === null || _b === void 0
          ? void 0
          // @ts-expect-error TS(2339): Property 'clientHeight' does not exist on type 'ne... Remove this comment to see the full error message
          : _b.clientHeight
      )
      setLoading(true)
    } else {
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      setWidth(null)
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      setHeight(null)
      setLoading(false)
    }
  }, [loading])
  const styleValue = useCallback(() => {
    let styles = {}
    if (height && width) {
      styles = { ...styles, width: `${width}px`, height: `${height}px` }
    }
    if (backgroundColor) {
      styles = { ...styles, backgroundColor }
    }
    return styles
  }, [height, width, backgroundColor])
  const buttonTemplate = _jsxs(
    "button",
    {
      ref: containerRef,
      type,
      className: [
        className,
        "g-button",
        `g-button-${color}-${variant}`,
        `g-button-${size}`,
        `${disabled ? "g-button-disabled" : ""}`,
        `${
          (label === null || label === void 0 ? void 0 : label.length)
            ? ""
            : "icon-only-button"
        }`,
        `${link ? "g-button-link" : ""}`,
        `${rounded ? `g-rounded-${rounded}` : ""}`,
      ].join(" "),
      style: styleValue(),
      onClick: (e: any) => {
        if (!disabled && onClick) {
          onClick(e)
        }
      },
      ...props,
      children: [
        icon &&
          iconPosition === "left" &&
          !_loading &&
          _jsx(
            FontAwesomeIcon,
            {
              style: label ? { marginRight: "0.5rem" } : {},
              icon: [iconLibrary, icon],
            },
            void 0
          ),
        _jsx(
          "span",
          {
            className: "g-button__label",
            children: _loading
              ? _jsx(
                  Spinner,
                  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                  { loading: true, size: spinnerSizes[size] },
                  void 0
                )
              : label,
          },
          void 0
        ),
        icon &&
          iconPosition === "right" &&
          !_loading &&
          _jsx(
            FontAwesomeIcon,
            {
              style: label ? { marginLeft: "0.5rem" } : {},
              icon: [iconLibrary, icon],
            },
            void 0
          ),
      ],
    },
    void 0
  )
  return tooltipText
    ? _jsx(Tooltip, { content: tooltipText, children: buttonTemplate }, void 0)
    : buttonTemplate
}
